import ISelect from "@components/forms/ISelect";
import { Config } from "@pages/configs/config";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MdOutlineFilterList } from "react-icons/md";



const FormSearch = (props) => {
    const { t } = useTranslation();
    const config = new Config(t);

    return (
<div className="d-flex align-items-center justify-content-end gap-2 ">
  <span className="d-none d-md-flex text-blue me-2 fw-medium">
    <MdOutlineFilterList size={23} className="text-blue" /> {t("filters")}
  </span>


      <div className="mb-1 mb-md-0" sm={6} md={6}>
        <ISelect
          id="ticket_status"
          name="ticket_status"
          label={t("select_ticket_status")}
          value={props.status}
          handleChange={props.setStatus}
          data={config.ticketStatusOptions()}
        />
      </div>

      <div sm={6} md={6}>
        <ISelect
          id="ticket_priority"
          name="ticket_priority"
          label={t("select_ticket_priority")}
          value={props.priority}
          handleChange={props.setPriority}
          data={config.ticketPriorityOptions()}
        />
      </div>


</div>
    );
};


export default FormSearch;